<template>
  <div class="xinsheng-warp">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "StatisticsData",
};
</script>

<style>
</style>